export default __webpack_public_path__ + "static/media/landscape18.59317f84.jpg";